export const RUNTIME_FAILURE_EVENT = 'platform:mfe-runtime-failure';

export type RuntimeFailureCode =
  'CORE_CAPABILITY_BLOCKED' | 'CORE_WORKSPACE_UNAVAILABLE' | 'UNEXPECTED_RENDER_FAILURE';

type RuntimeFailureDetail = Readonly<{
  code: RuntimeFailureCode;
  contractVersion: 1;
  retryable: true;
}>;
/**
Creates an event indicating that a core capability is blocked.
@returns A runtime failure event for the blocked core capability.
*/
export function createCoreCapabilityBlockedEvent(): CustomEvent<RuntimeFailureDetail> {
  return createRuntimeFailureEvent('CORE_CAPABILITY_BLOCKED');
}

/**
Creates an event indicating that the core workspace is unavailable.
@returns A runtime failure event for the unavailable core workspace.
*/
export function createCoreWorkspaceUnavailableEvent(): CustomEvent<RuntimeFailureDetail> {
  return createRuntimeFailureEvent('CORE_WORKSPACE_UNAVAILABLE');
}

/**
Creates an event indicating that an unexpected rendering failure occurred.
@returns A runtime failure event for the unexpected rendering failure.
*/
export function createUnexpectedRenderFailureEvent(): CustomEvent<RuntimeFailureDetail> {
  return createRuntimeFailureEvent('UNEXPECTED_RENDER_FAILURE');
}

/**
Creates a framework-neutral runtime failure event for the Shell.
@param code - Runtime failure code included in the event detail.
@returns A bubbling and composed custom event containing the failure detail.
*/
function createRuntimeFailureEvent(code: RuntimeFailureCode): CustomEvent<RuntimeFailureDetail> {
  return new CustomEvent(RUNTIME_FAILURE_EVENT, {
    bubbles: true,
    composed: true,
    detail: Object.freeze({
      contractVersion: 1 as const,
      code,
      retryable: true as const,
    }),
  });
}
